import React from "react";
import { useTranslation } from "src/context/Translations/context";
import List from "src/components/List";
import { RCCButton, RCCGrid, RCCIcon, RCCTooltip } from "react-common-components";

export interface IComponentTabObjectiveProject{
    list: any;
}

const TabObjectiveProject: React.FC<IComponentTabObjectiveProject> = ({
	list
}) => {
	const { translate } = useTranslation();

	const colName = (row: any) => (
		<>
			{row.pra005Pra002Nome}			
		</>
	);

	const colDescription = (row: any) => (
		<>
			{row.pra005Pra002Descricao}			
		</>
	);

	const colButton = (row: any) => (
		<>
			<RCCTooltip
				text={translate("Ir ao projeto")}
				color="grey"
			>
				<RCCButton
					color="transparent"
					size="md"
					onClick={() => window.open(`/projects/panel/${row.pra005Pra002Id}`)}
				>
					<RCCIcon
						name="linkExternal"
						color="var(--grey)"
					/>
				</RCCButton>
				
			</RCCTooltip>
		</>
	);

	return (
		<RCCGrid
			container	
			item
			direction="column"
			alignItems="center"
			justifyContent="center"
		>
			<RCCGrid
				container
				item
			>
				<List 
					showHeader
					data={list || []}
					columns={[{
						idColumn: "name",
						nameColumn: translate("Projeto"),
						xs: 12,
						sm: 5,
						justify: "left",
						truncate: true,
						cellRenderer: colName
					},
					{
						idColumn: "description",
						nameColumn: translate("Descrição"),
						xs: 12,
						sm: 5,
						justify: "left",
						truncate: true,
						cellRenderer: colDescription
					},
					{
						idColumn: "button",
						nameColumn: translate(""),
						justify: "left",
						xs: 12,
						sm: 2,
						cellRenderer: colButton
					}]}
					layout="table"
				/>
			</RCCGrid>
		</RCCGrid>
	);
};

export default TabObjectiveProject;
